import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPol = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={20} height={20} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17.292 11.042A7.294 7.294 0 0 1 10 18.333a7.294 7.294 0 0 1-7.291-7.291A7.294 7.294 0 0 1 10 3.75a7.294 7.294 0 0 1 7.292 7.292M10 6.667v4.166'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M7.5 1.667h5'
    />
  </svg>
);
export default SvgPol;
